'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _components = require('components');

var _GenericSettings = require('redux/modules/GenericSettings');

var mapStateToProps = function mapStateToProps(state) {
  return {
    active: state.genericSettings.configuration.deleteQuotesOnSend || false,
    value: state.genericSettings.configuration.deleteQuotesOnSendValue
  };
};
// import { toggleDeleteQuotesOnSend, deleteQuotesOnSendValue } from 'redux/modules/GenericSettings'


var mapDispatchToProps = {
  changeProperty: _GenericSettings.changeStorageOptionProperty
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_components.DeleteQuotesOnSend);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/DeleteQuotesOnSend/DeleteQuotesOnSend.js
// module id = 1625
// module chunks = 0